var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "url(#paint0_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 22.3333H19.0002V20.6667C19.0002 20.0036 18.7368 19.3678 18.2679 18.8989C17.7991 18.4301 17.1632 18.1667 16.5002 18.1667H11.5002C10.8371 18.1667 10.2012 18.4301 9.7324 18.8989C9.26355 19.3678 9.00016 20.0036 9.00016 20.6667V22.3333H7.3335V20.6667C7.3335 19.5616 7.77248 18.5018 8.55388 17.7204C9.33529 16.939 10.3951 16.5 11.5002 16.5H16.5002C17.6052 16.5 18.665 16.939 19.4464 17.7204C20.2278 18.5018 20.6668 19.5616 20.6668 20.6667V22.3333ZM14.0002 14.8333C13.3436 14.8333 12.6934 14.704 12.0867 14.4527C11.4801 14.2015 10.9289 13.8332 10.4646 13.3689C10.0003 12.9046 9.63204 12.3534 9.38076 11.7468C9.12949 11.1401 9.00016 10.49 9.00016 9.83334C9.00016 9.17673 9.12949 8.52655 9.38076 7.91993C9.63204 7.3133 10.0003 6.7621 10.4646 6.29781C10.9289 5.83352 11.4801 5.46522 12.0867 5.21395C12.6934 4.96267 13.3436 4.83334 14.0002 4.83334C15.3262 4.83334 16.598 5.36013 17.5357 6.29781C18.4734 7.23549 19.0002 8.50726 19.0002 9.83334C19.0002 11.1594 18.4734 12.4312 17.5357 13.3689C16.598 14.3066 15.3262 14.8333 14.0002 14.8333ZM14.0002 13.1667C14.8842 13.1667 15.7321 12.8155 16.3572 12.1904C16.9823 11.5652 17.3335 10.7174 17.3335 9.83334C17.3335 8.94929 16.9823 8.10144 16.3572 7.47632C15.7321 6.8512 14.8842 6.50001 14.0002 6.50001C13.1161 6.50001 12.2683 6.8512 11.6431 7.47632C11.018 8.10144 10.6668 8.94929 10.6668 9.83334C10.6668 10.7174 11.018 11.5652 11.6431 12.1904C12.2683 12.8155 13.1161 13.1667 14.0002 13.1667Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 4.15484,
    y1: 4.60708e-7,
    x2: 25.4973,
    y2: 29.4365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A94B17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.935e554a0b5fda4288a51ee60aeec17e.svg";
export { ForwardRef as ReactComponent };